import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.visible = false
  }

  toggle() {
    this.visible = !this.visible

    if (this.hasContentTarget) {
      if (this.visible) {
        this.contentTarget.classList.remove('hidden')
      } else {
        this.contentTarget.classList.add('hidden')
      }
    }
  }

  show() {
    this.visible = true
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove('hidden')
    }
  }

  hide() {
    this.visible = false
    if (this.hasContentTarget) {
      this.contentTarget.classList.add('hidden')
    }
  }
}
